<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ $tl("labels.clickAndCollect.modals.titles.warning") }}</h5>
        <div slot="body">
            {{ $tl("labels.clickAndCollect.modals.futuresOrdersExistForSlots") }}
            <command-list
                :commands="commands"
                :restaurant_id="restaurant_id"
                :columns="{
                    number: true,
                    client: true,
                    status: {
                        show: true,
                        readonly: true,
                    },
                    date: true,
                    slot: true,
                    price: true,
                    products: true,
                    actions: false,
                }"
                @next="$emit('next', $event)"
                @previous="$emit('previous', $event)"
                class="modal-table mt-3" />
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="$emit('close')">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button type="button" class="btn btn-sm btn-success btn-circle ms-2" @click="$emit('cancel-and-save')">
                {{ $tl("labels.form.actions.cancelAndRefund") }}
            </button>
            <button type="button" class="btn btn-sm btn-success btn-circle ms-2" @click="$emit('save')">{{ $tl("labels.form.actions.save") }}</button>
        </div>
    </modal>
</template>

<script>
import CommandList from "../../../clickAndCollect/Command/CommandList";

export default {
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            e.stopPropagation();
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    props: {
        commands: {
            required: true,
        },
        restaurant_id: {
            required: true,
        },
    },
    components: {
        CommandList,
    },
};
</script>
